export const LINKEDIN_PARTNER_ID = '6771993';
export const LINKEDIN_CONVERSION_IDS = {
  BRAND_APPLICATION: '16151138'
};
